module.exports = __webpack_public_path__ + "pic/57.71872a6d.png";